var React = require('react');

function LinkedinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M19 0H5C2.2 0 0 2.2 0 5v14c0 2.8 2.2 5 5 5h14c2.8 0 5-2.2 5-5V5c0-2.8-2.2-5-5-5ZM8 19H5V8h3v11ZM6.5 6.7c-1 0-1.8-.8-1.8-1.8s.8-1.8 1.8-1.8S8.2 4 8.2 5c0 1-.7 1.7-1.7 1.7ZM20 19h-3v-5.6c0-3.4-4-3.1-4 0V19h-3V8h3v1.8c1.4-2.6 7-2.8 7 2.5V19Z"}));
}

LinkedinInline.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = LinkedinInline;

LinkedinInline.default = LinkedinInline;
